export const DEFAULT_ROW_COUNT = 10;
export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100];
export const API_PAGE_SIZE = 100;
